const IDLE_TIMEOUT_MS = 3000;

export function scheduleIdle(callback: () => void): () => void {
	if (typeof window.requestIdleCallback === "function") {
		const handle = window.requestIdleCallback(callback, { timeout: IDLE_TIMEOUT_MS });
		return () => window.cancelIdleCallback(handle);
	}

	const handle = window.setTimeout(callback, 0);
	return () => window.clearTimeout(handle);
}
